export const environment = {
    production: false,
    name:'azure development environment',
    code: 1001,
    apiURL: 'https://fills.api.apps.test.pomvelocity.com/api',
    authUrl: 'https://apps.test.pomvelocity.com/',
    contractUrl: 'https://operators.apps.test.pomvelocity.com/approvals/operators/application-process/contract',
    version: 2.2
   };